import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { AdminLayout, AdminHeader, AdminNavbar } from '../../../layout';
import { PageList } from './PageList';
import BuildInfo from './BuildInfo';
import PageSetPicker from './PageSetPicker';

export default class AdminHome extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    params: PropTypes.object,
    location: PropTypes.object,
    isLoading: PropTypes.bool.isRequired,
    pages: PropTypes.array,
    clonePage: PropTypes.func.isRequired,
    savePage: PropTypes.func.isRequired,
    saveAndReloadPages: PropTypes.func.isRequired,
    makeLive: PropTypes.func.isRequired,
    makeDraft: PropTypes.func.isRequired,
    switchLiveAndDraft: PropTypes.func.isRequired,
    switchFacilityId: PropTypes.func.isRequired,
    saveRecipientEmail: PropTypes.func,
    onBuildSite: PropTypes.func.isRequired,
    search: PropTypes.func.isRequired,
    updateFilters: PropTypes.func.isRequired,
    selectedFilters: PropTypes.object.isRequired,
    isSiteLoading: PropTypes.bool,
    pageSet: PropTypes.string,
    publishPage: PropTypes.func.isRequired,
    pushRoute: PropTypes.func.isRequired,
    profile: PropTypes.object.isRequired,
    toggleAuthenticatedPages: PropTypes.func.isRequired,
    onlyShowAuthenticated: PropTypes.bool.isRequired,
    languagesEnabled: PropTypes.bool,
    builderListViewFeature: PropTypes.bool,
    clearFilters: PropTypes.func.isRequired,
    nonDefaultLanguages: PropTypes.array,
  };

  handlePageSetSelect = pageSet => this.props.onBuildSite(pageSet);

  render() {
    const {
      params,
      isLoading,
      pages,
      clonePage,
      savePage,
      saveAndReloadPages,
      makeLive,
      makeDraft,
      switchLiveAndDraft,
      switchFacilityId,
      pageSet,
      isSiteLoading,
      publishPage,
      pushRoute,
      profile,
      toggleAuthenticatedPages,
      onlyShowAuthenticated,
      languagesEnabled,
      builderListViewFeature,
      search,
      updateFilters,
      selectedFilters,
      clearFilters,
      nonDefaultLanguages,
      saveRecipientEmail,
    } = this.props;

    const pageComponentProps = {
      pages,
      isLoading,
      companyId: params.companyId,
      clonePage,
      savePage,
      saveAndReloadPages,
      makeLive,
      makeDraft,
      switchLiveAndDraft,
      switchFacilityId,
      publishPage,
      pushRoute,
      profile,
      toggleAuthenticatedPages,
      onlyShowAuthenticated,
      languagesEnabled,
      builderListViewFeature,
      search,
      updateFilters,
      selectedFilters,
      clearFilters,
      nonDefaultLanguages,
      saveRecipientEmail,
    };

    const header = (
      <AdminHeader title="Pages" />
    );

    const navbar = (
      <AdminNavbar home={{ active: true }} />
    );

    return (
      <AdminLayout header={header} navbar={navbar}>
        <Helmet title="All Pages" />
        <PageList {...pageComponentProps} />
        <BuildInfo />
        {!pageSet &&
          <PageSetPicker
            onSelect={this.handlePageSetSelect}
            isSaving={isSiteLoading}
          />
        }
      </AdminLayout>
    );
  }
}
